import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_up",
  "use": "icon-icon_arrow_up-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_arrow_up\"><path d=\"M12.098 8.764 7.236 3.902a.333.333 0 0 0-.472 0L1.902 8.764a.333.333 0 0 0 .236.57h9.724a.333.333 0 0 0 .236-.57Z\" fill=\"#F53134\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol